"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function steem(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.07664 6.17186C7.23864 6.19961 6.83514 7.27436 7.06014 8.50211C7.25514 9.55436 9.69039 13.6291 9.58989 15.0271C9.51189 15.9046 7.51239 17.9634 7.30164 17.8261C7.07139 17.7624 7.90914 16.3636 7.59864 15.1981C7.23714 13.8391 5.09364 10.3261 5.09589 8.77511C5.09589 7.64036 6.93189 6.09836 7.07589 6.17186H7.07664ZM11.6584 4.56686C11.8639 4.60211 11.3509 5.97386 11.6374 7.53611C11.8849 8.88011 14.9921 14.0761 14.8631 15.8574C14.7626 16.9779 12.2141 19.6006 11.9441 19.4274C11.6516 19.3471 12.7196 17.5629 12.3236 16.0764C11.8639 14.3454 9.13014 9.86486 9.13239 7.88711C9.13239 6.43886 11.4739 4.47461 11.6584 4.56761V4.56686ZM16.3871 6.17186C16.5491 6.19961 16.1464 7.27436 16.3706 8.50211C16.5656 9.55436 19.0009 13.6291 18.9011 15.0271C18.8239 15.9046 16.8236 17.9634 16.6121 17.8261C16.3826 17.7624 17.2196 16.3636 16.9091 15.1981C16.5484 13.8391 14.4041 10.3261 14.4064 8.77511C14.4064 7.64036 16.2439 6.09836 16.3871 6.17186Z", fill: color }));
}
exports["default"] = steem;
//# sourceMappingURL=steem.js.map